import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TextAlignment } from '../../text/text.model';

@Component({
  selector: 'text-alignment-chooser',
  templateUrl: './text-alignment-chooser.component.html',
  styleUrls: [ './text-alignment-chooser.component.scss' ],
})
export class TextAlignmentChooserComponent
{
  @Input('alignment') public alignment: TextAlignment;
  @Output() public alignmentChange: EventEmitter<TextAlignment> =
    new EventEmitter();

  public readonly textAlignment: any = TextAlignment;

  public setAlignment(newAlignment: TextAlignment): void
  {
    this.alignment = newAlignment;
    this.alignmentChange.emit(newAlignment);
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/text-editing/text-alignment-chooser.component.ts